import styled from 'styled-components';
import { backgroundImage } from '../../../contants';
// import LinkButton from '../../LinkButton/LinkButton';
// import { useState } from 'react';
import skillsImage from '../../../assets/skills.png';

// const value = 'More';

const SkillsTile = () => {
  // const [animate, setAnimate] = useState(false);
  // const hoverHandler = () => {
  //   setAnimate(true);
  // };

  // const outHandler = () => {
  //   setAnimate(false);
  // };

  return (
    <Wrapper
    // onMouseOver={() => value && hoverHandler()}
    // onMouseOut={() => value && outHandler()}
    >
      <ProjectBackgroundImage alt='error' src={backgroundImage.project1} />
      <SkillWrapper>
        <Header>Tech Stack</Header>
        <SkillsImage src={skillsImage} />
        {/* <LinkButtonWrapper>
          <LinkButton key='skills' animate={animate} value={value} />
        </LinkButtonWrapper> */}
      </SkillWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  background-color: ${({ theme }) => theme.tileBackground};
  border-radius: 24px;
`;

const Header = styled.div`
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 8px;
  line-height: 32px;
  color: ${({ theme }) => theme.background};
  filter: drop-shadow(0.1rem 0.1rem 0.2rem hsla(0, 24%, 30%, 0.3));
`;

const ProjectBackgroundImage = styled.img`
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

const SkillWrapper = styled.div`
  position: absolute;
  inset: 0;
  padding: 40px 44px;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 4px;
  line-height: 32px;
  @media (max-width: 500px) {
    padding: 20px 22px;
  }
`;

const SkillsImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: drop-shadow(0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.1));
`;

export default SkillsTile;
